import * as Types from '../constants/Types';
import Homestay from '../models/Homestay';
import { HOMESTAY } from '../constants/Define';
import { PAGINATION } from '../constants/Define';

const initialState = {
    isFetching: false,
    isFetched: false,
    homestays: [],
    allHomestays: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        homestay: new Homestay(),
    },
    tagGroups: [],
    homestayActives: [],
    isFetchClearCache: false,
    rateCompareList: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.HOMESTAY_All_SUCCESS:
            return { ...state, allHomestays: action.homestays };
        case Types.HOMESTAY_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.HOMESTAY_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                homestays: action.homestays,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.HOMESTAY_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, homestays: [] };
        case Types.HOMESTAY_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.HOMESTAY_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: { homestay: action.homestay, }
            };
        case Types.HOMESTAY_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.HOMESTAY_DETAIL_CREATE_ACTION:
            return { ...state, isFetching: true };

        case Types.HOMESTAY_TAG_GROUP_DETAIL_SKU_ACTION:
            return { ...state, isFetching: true };
        case Types.HOMESTAY_TAG_GROUP_DETAIL_SKU_SUCCESS:
            return { ...state, isFetching: false, tagGroups: action.tagsGroupDetail };
        case Types.HOMESTAY_TAG_GROUP_DETAIL_SKU_ACTIVE_ACTION:
            return { ...state, isFetching: true };
        case Types.HOMESTAY_TAG_GROUP_DETAIL_SKU_ACTIVE_SUCCESS:
            return { ...state, isFetching: false };
            
        case Types.HOMESTAY_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.HOMESTAY_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.HOMESTAY_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.HOMESTAY_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.HOMESTAY_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.HOMESTAY_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.HOMESTAY_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.HOMESTAY_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isFetched: true };
        case Types.HOMESTAY_ALL_ACTIVE_SUCCESS: 
            return { ...state, homestayActives: action.homestayActive }
        case Types.CLEAR_CACHE_ACTION:
            return { ...state, isFetching: true, isFetchClearCache: true };
        case Types.CLEAR_CACHE_SUCCESS:
            return { ...state, isFetching: false, isFetchClearCache: false };
        case Types.RATE_LIST_COMPARE_ACTION:
            return { ...state, isFetching: true, rateCompareList: [] };
        case Types.RATE_LIST_COMPARE_SUCCESS:
            return {
                ...state,
                isFetching: false,
                rateCompareList: action.rateCompareList.__data__,
            };
        case Types.RATE_LIST_COMPARE_FAIL:
            return { ...state, isFetching: false };
        default:
            return state;
    }
}
